import { render, staticRenderFns } from "./UserContentNewArrivalNotice.vue?vue&type=template&id=262b9f92&"
import script from "./UserContentNewArrivalNotice.vue?vue&type=script&lang=ts&"
export * from "./UserContentNewArrivalNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports